<template>
  <div class="tags-warys" :class="className"> 
    <span slot="reference" :class="`warning-level-${warningLevel} tags`" @click.stop="showWarningTimeInfo">{{ CONSTANT.WARNING_LEVEL_INFO[warningLevel].TEXT }}</span>
    <van-popup
      v-model="timePopup" 
      overlay-class="van-popup-class"
      @click.stop="closeVanPopup" 
      position="bottom"
    >
    <div class="record-wary">
        <div class="record-tit">预警记录</div>
        <div class="record-table">
          <div class="record-table-titles">
            <div class="flex1">预警时间</div>
            <div class="div2">预警级别</div>
            <div class="flex1">触发指标</div>
          </div>
          <div class="record-table-titles record-table-body" v-for="(item,i) of warningTimeArray" :key="i" :class="`record-table-item${i}`">
            <div class="flex1">{{ item.warningTimes }}</div>
            <div class="div2"><i v-if="item.level" :class="'jb-i-'+item.level"></i> {{ item.text }}</div>
            <div class="flex1">{{ item.desc }}</div>
          </div>
          <!-- <table>
            <thead class="record-table-tit">
              <tr>
                <td class="td1">预警时间</td>
                <td class="td2">预警级别</td>
                <td class="td3">触发指标</td>
              </tr>
            </thead>
            <tbody class="record-table-item">
              <tr v-for="(item,i) of warningTimeArray" :key="i" :class="`record-table-item${i}`">
                <td>{{ item.warningTimes }}</td>
                <td><i v-if="item.level" :class="'jb-i-'+item.level"></i> {{ item.text }}</td>
                <td>{{ item.desc }}</td>
              </tr>
            </tbody>
          </table> -->
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
// Notify
import { Popup } from 'vant';
export default {
  name: 'WarningTime',
  components: { 
    "van-popup": Popup,
  },
  props: {
    warningTime: {
      type: String,
      default: ''
    },
    warningLevel: {
      type: [String, Number],
      default: ''
    },
    warningTimeArray: {
      type: Array,
      default: () => {
        return []
      }
    },
    className: {
      type: String,
      default: ''
    }
  },
  data(){
    return {
      timePopup:false,
      CONSTANT:{
        WARNING_LEVEL: [1, 2, 3],
        WARNING_LEVEL_INFO:{
          1: {
            TEXT: '一般',
            TYPE: 1
          },
          2: {
            TEXT: '严重',
            TYPE: 2
          },
          3: {
            TEXT: '重大',
            TYPE: 3
          }
        }
      },
    }
  },
  methods:{
    closeVanPopup(){ 
       return false
    },
    showWarningTimeInfo(){
      if(this.warningTimeArray && this.warningTimeArray.length){
        this.timePopup = !this.timePopup
      } 
      return false
    }
  }
}
</script>

<style scoped>
  .tags-warys{
    display: inline;
  }
  span.tags { 
      padding: 0 10px;
      height: 54px; 
      line-height: 54px;  
      margin-left: 0px; 
      font-size: 30px;    
      cursor: pointer; 
      text-align: center;
      border-radius: 4px; 
      color: #FFFFFF;
      margin-right: 15px; 
    }
    .warning-level-1{
      background: #E4C400;
    }
    .warning-level-2{
      background: #F48B24;
    }
    .warning-level-3{
      background: #ED2B28;
    }
  .triangle{
    display: inline-block;
    cursor: pointer;
    position: relative;
    left: -5px;
  }
  .triangle i{
    display: inline-block;
    width: 0;
    height: 0;
    border:5px solid #8A9098;
    border-color: #8A9098 transparent transparent transparent;
    position: relative;
    top:4px;
    left:5px;
  }
  .record-wary{
    width: 100%;
    font-size: 32px;
    padding: 10px;
    box-sizing: border-box;
    padding-bottom: 50px;
  }
  .record-tit{
    width: 100%;
    color:var(--c-theme-font);
    padding:5px 0 10px 0;
  }
  .record-table{
    width: 100%;
  }
  .record-table-titles{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }
  .record-table-titles >div{ 
    text-align: center;
    padding: 6px 0;
  } 
  .flex1{
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }
   .record-table-titles >.div2{
     width: 150px;
   }
  .record-table-item1{
    background: #F2F3F7;
  }
  .record-table-titles >div i{
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    position: relative;
    top:-2px;
  }
  .record-table-titles >div i.jb-i-3{
    background: #ED2B28;
  }
  .record-table-titles >div i.jb-i-2{
    background: #F48B24;
  }
  .record-table-titles >div i.jb-i-1{
    background: #E4C400;
  }
  .record-table-body > div{
    font-size: 30px;
  }
</style>
